import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../Environment';
import { catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginAppService {

  constructor(private httpClient: HttpClient, private router:Router) { }

  apiurl=environment.baseUrl;
  email: string = '';
  userData: any;
  //Get Client by Id
  // private GetUserMasterDetailUrl = 'https://app.celoxis.com/psa/api/v2/users?filter';
  // GetUsermasterDetails(Detail:any){
  //   var req=this.GetUserMasterDetailUrl;
  //   return this.httpClient.post(req,Detail);
  // }
  private getRandomAuthorizationKey(): string {
    const keys = environment.AuthorizationKeys;
    const randomIndex = Math.floor(Math.random() * keys.length);
    //alert(`Using Authorization Key: ${randomIndex}`);
    return keys[randomIndex];
  }
  // GetUsermasterDetails(Detail:string) {

  //   // console.log('email:' + Detail)
  //   let url = 'https://app.celoxis.com/psa/api/v2/users?filter={"email":"'+ Detail + '"}';
  //  const headers = new HttpHeaders({
  //   //'Authorization': 'EdRKb9nYgGiqLgiULjC5scu161r7UKHMaP6i6EDQ',
  //   'Authorization': this.getRandomAuthorizationKey(),
  //   'Content-Type': 'application/json;charset=UTF-8',
  //   'Accept': '*/*' , 
  // });
  // // console.log('url:' + url)
  // // console.log('headers:' + headers)
  //   return this.httpClient.get(url, { headers: headers })
     
  // }

  private GetUser = this.apiurl + 'Login/GetUser'
  getUserMasterDetails(detail: string) {
  const body = {
    email: detail,
    authorizationKey: this.getRandomAuthorizationKey()
  };

  return this.httpClient.post(this.GetUser,body);
}

  isLoggedIn(): boolean {
    // Implement your logic to check if the user is logged in
    // For example, you can check if a user token exists in local storage
    return !!localStorage.getItem('loginDetails');
  }

}
